import { Environment } from './environment.interface';
export { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  brands: {
    calibrant: {
      baseUrl: '/',
    },
  },
  defaults: {
    brand: 'calibrant',
    locale: 'en-us',
  },
  apiKey: '',
};
